<div 
class="root-container">
	@if (withClearSelection() && (file || imageUrl)) {
    <i 
    class="bi bi-x-lg close"
    (click)="file = undefined; imageUrl = undefined; $event.preventDefault()"></i>
	}
	<div
	class="content"
	[class.view]="!editMode()"
	(dragover)="dragOver($event)" 
	(drop)="drop($event)" 
	(click)='file_input.click()'
	[style.width]="width()"
	>
		@if (!imageUrl) {
			<img 
			class="placeholder-image"
			src='assets/images/defaults/default_image.png'
			alt="">
			<div class="message">
				<ng-content></ng-content>
			</div>
		} @else {
			<img 
			class="subject"
			[src]='imageUrl' alt="">
		}
		<input type="file" #file_input (change)="onSelect($event)" [accept]="accepts()" style="display:none;">
	</div>
</div>